module.exports = __webpack_public_path__ + "static/media/clean-your-electron-warning.bc114527.gif";